<div class="mb-s report-data pt-xxs">
  <div data-pgr-id="report-area" *ngFor="let item of data">
    <h2 [id]="item.anchorId" class="mb-xs ml-xxs text-2xl font-light subheader">
      {{ item.anchorlabel }}
    </h2>

    <div class="ml-xxs mb-xxs" *ngIf="item.content.length === 0">
      <span id="notAvailableMessage">
        There is no {{ item.anchorlabel }} available for this claim.
      </span>
    </div>

    <div class="mb-xs ml-xxs" *ngFor="let content of item.content">
      <h4 [id]="item.anchorId" class="mb-xxs text-lg" *ngIf="content.subHeader">
        {{ content.subHeader }}
      </h4>
      <div *ngIf="content.data.length > 0">
        <cui-data-list [multiColumn]="false">
          <cui-data-list-row
            *ngFor="let data of content.data"
            labelSpan="30"
            [label]="data.label"
          >
            {{ data.value }}
          </cui-data-list-row>
        </cui-data-list>
      </div>
    </div>
  </div>
  <div class="empty-space"></div>
</div>
